// DS: i3.5
import React from 'react';
import IconWrap from '../../IconWrap';
const ArrowLeft = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M9.59 2.285l-4.95 4.95a1 1 0 000 1.414l4.95 4.95a1 1 0 001.414-1.414L6.76 7.94 11.004 3.7a1 1 0 10-1.415-1.414z",
        clipRule: "evenodd"
    })));
};
ArrowLeft.displayName = 'ArrowLeft';
export default ArrowLeft;
